module.exports = __webpack_public_path__ + "static/q5_x-700c8ac1d2232263e8efb3e486ce7057.png";